import React from 'react'
import ReactDOM from 'react-dom'
import AnnotationBubble from './AnnotationBubble'

class AnnotationBubbles extends React.Component {
  render() {
    const bubbles = this.props.annotations.map((ann) => {
      let allIndex = this.props.allAnnotations.findIndex((a) => { return a.id == ann.id })
      return <AnnotationBubble klass={this.props.klass} annotation={ann} index={allIndex + 1} key={ann.id} />
    })

    return (
      <div>
        {bubbles}
      </div>
    )
  }
}

export default AnnotationBubbles